export const BUYER = "BUYER";
export const CHECKOUT = "CHECKOUT";

export const SET_ID = "SET_ID";
export const RESET = "RESET";
export const SET_ACTIVE_STEP = "SET_ACTIVE_STEP";
